import React from "react";
import TableList from "src/components/Admin/TableList/TableList";

export default function ProcessAssociate() {
  return (
    <>
      <div>
        <TableList Role="Process-Associate-MIS" />
      </div>
    </>
  );
}
